import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

//import { Subscription } from 'rxjs/Subscription';
import { MdListModule } from '@angular/material';
// import * as Ps from 'perfect-scrollbar';
import { MenuItems, Menu } from '../../shared/menu-items/menu-items';
import { UserType } from '../../shared/constants/permission';
import { AppConstants } from '../../shared/constants/constants';
import { Utility } from '../../common/utility';
import { BaseUrl } from '../../shared/urls/base.url';
import { BaseService } from '../../shared/services/base.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
  menuItems: Menu[];
  @Output() selectSubMenu = new EventEmitter<any>();

  constructor(public menu: MenuItems) {

  }

  ngOnInit(): void {
    this.menuItems = this.menu.getMenu();
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  /**
   * hide menu when click on submenu
   */
  onClickSubMenu() {
    this.selectSubMenu.emit();
  }

  updateMenu() {
    this.menuItems = this.menu.getMenu();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/menu/menu.component.ts